import { Formik, Form } from 'formik'
import { Grid2 } from '@mui/material'
import { Field } from 'formik'
import { Button } from '@mui/material'
import * as Yup from 'yup'
import { TextFormField } from '../../../shared/components/formfields/TextFormField'
import { useAdminCountry } from '../../../assets/api/useAdminApi'
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField'
import { Grid_Gap } from '../../../shared/constants'
import { useToaster } from '../../../shared/utils/ToasterProvider'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../../assets/nodeApi/axiosInstance'
import CustomDivider from '../../../shared/utils/CustomDivider'

const StateForm = ({ initialState = null, isEditing = false, onSuccess = () => { } }) => {
    const { data: countryList, isLoading: countryLoading } = useAdminCountry();
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();

    const countryOption = countryList?.data?.map((item) => ({
        id: item?.id,
        label: item?.country_name,
        value: item?.country_name,
    })) || [];

    const initialValues = {
        country_id: initialState?.country_id || '',
        state_name: initialState?.state_name || '',
    }

    const validationSchema = Yup.object().shape({
        country_id: Yup.string().required('Country is required'),
        state_name: Yup.string().required('State name is required'),
    })

    const createStateMutation = useMutation({
        mutationFn: (formData) => api.post("state/create", formData),
    });

    const updateStateMutation = useMutation({
        mutationFn: (formData) => api.put(`state-update/${initialState?.id}`, formData),
    });

    const handleSubmit = (values, { resetForm }) => {
        if (isEditing) {
            updateStateMutation.mutate(values, {
                onSuccess: (response) => {
                    if (response?.data?.message) {
                        showToaster("State updated successfully!", '', 'success');
                        queryClient.invalidateQueries({ queryKey: ["all-states-list"] });
                        onSuccess();
                    } else {
                        showToaster('Something went wrong!', '', 'error');
                    }
                },
                onError: (error) => {
                    showToaster(error?.data?.error || "Failed to update state", '', 'error');
                }
            });
        } else {
            createStateMutation.mutate(values, {
                onSuccess: (response) => {
                    if (response?.data?.message) {
                        showToaster("State added successfully!", '', 'success')
                        resetForm();
                        queryClient.invalidateQueries({ queryKey: ["all-states-list"] });
                    } else {
                        showToaster('Something went wrong!', '', 'error')
                    }
                },
                onError: (error) => {
                    showToaster(error?.data?.error || "Failed to add state", '', 'error')
                }
            });
        }
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
            {({ resetForm }) => (
                <Form>
                    <Grid2 container spacing={"20px"}>
                        <Grid2 children size={4}>
                            <Field
                                name="state_name"
                                component={TextFormField}
                                placeholder="Enter State Name"
                                label="State Name"
                                isRequired={true}
                            />
                        </Grid2>
                        <Grid2 children size={4}>
                            <Field
                                name="country_id"
                                component={IdAutoCompleteField}
                                options={countryOption}
                                label="Select Country"
                                isRequired={true}
                                isLoading={countryLoading}

                            />
                        </Grid2>
                    </Grid2>



                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }}>
                        <Grid2 children size={{ xs: 12, sm: 3 }}
                            onClick={() => {
                                resetForm();
                                if (isEditing) {
                                    onSuccess();
                                }
                            }}
                        >
                            <Button variant='outlined' fullWidth onClick={resetForm}>
                                {isEditing ? "Cancel" : "Reset"}
                            </Button>
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 3 }}
                            disabled={createStateMutation.isLoading || updateStateMutation.isLoading}
                        >
                            <Button variant='contained' type="submit" fullWidth>
                                {isEditing ? "Update" : "Submit"}
                            </Button>
                        </Grid2>
                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export default StateForm